import { css, keyframes } from 'styled-components';

export const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const reducedMotion = (styles) => css`
  @media (prefers-reduced-motion: reduce) {
    ${styles}
  }
`;

export const hoverScale = ({
  hoverScaleValue = 1.15,
  activeScaleValue = 1.05,
  durationMs = 200,
  easing = 'ease',
  targetSelector = '&',
  triggerSelector = '&',
} = {}) => {
  const triggerSelectors = Array.isArray(triggerSelector) ? triggerSelector : [triggerSelector];

  const rules = triggerSelectors.map((selector) => {
    // Self-hover: &:hover { ... }
    if (selector === '&' && targetSelector === '&') {
      return css`
        &:hover {
          transform: scale(${hoverScaleValue});
        }

        &:active {
          transform: scale(${activeScaleValue});
        }
      `;
    }

    // Parent/other trigger: ${trigger}:hover ${target} { ... }
    return css`
      ${selector}:hover ${targetSelector} {
        transform: scale(${hoverScaleValue});
      }

      ${selector}:active ${targetSelector} {
        transform: scale(${activeScaleValue});
      }
    `;
  });

  return css`
    ${targetSelector} {
      transition: transform ${durationMs}ms ${easing};
      transform-origin: center;
    }

    ${rules}

    ${reducedMotion(css`
      ${targetSelector} {
        transition: none;
      }
    `)}
  `;
};
